<template>
  <v-card
    ref="booking_pickup_delivery"
    v-if="visible"
    id="booking-pickup-delivery"
    elevation="0"
    class="mx-auto secondary rounded-0"
  >
    <CardHeader title="2. HVOR?" />
    <v-row
      no-gutters
      :class="this.$vuetify.breakpoint.smAndDown ? 'px-0' : 'pt-4 pb-2 px-7'"
    >
      <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 5.5">
        <Address :addressType="pickupType" @forceFocus="forceFocus()" />
      </v-col>
      <v-col
        :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 1"
        style="text-align:center"
      >
        <v-icon
          v-show="swapEnabled"
          :disabled="!swapEnabled"
          @click="swapPickupAndDelivery"
        >
          {{ swapIcon }}
        </v-icon>
      </v-col>
      <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 5.5">
        <Address :addressType="deliveryType" @forceFocus="forceFocus()" />
      </v-col>
    </v-row>
    <v-row
      no-gutters
      :class="this.$vuetify.breakpoint.smAndDown ? 'px-2' : 'pt-0 pb-8 px-10'"
    >
      <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 5.5">
        <b>Har du brug for hjælp til flere stop - giv os et kald på 70 22 70 22</b>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Address from "@/components/BookingAddress.vue";
import { dictionary } from "../helpers";
import CardHeader from "@/components/templates/CardHeader.vue";

export default {
  name: "PickupDelivery",
  components: {
    Address,
    CardHeader
  },
  created() {
    const bookingType = this.$store.getters["user/bookingType"];
    const useOwnAddressAs = this.$store.getters["user/useOwnAddressAs"];
    const ownAddressEditable = this.$store.getters["user/ownAddressEditable"];

    this.swapEnabled =
      bookingType == dictionary.constants.booking_types.courier &&
      (!useOwnAddressAs || (useOwnAddressAs && ownAddressEditable));
  },
  data: () => ({
    swapEnabled: true,
    swapIcon: dictionary.mdi.swap,
    pickupType: dictionary.constants.address_types.pickup,
    deliveryType: dictionary.constants.address_types.delivery
  }),
  computed: {
    visible: {
      get() {
        return this.$store.state.booking.data.account;
      }
    }
  },
  watch: {
    visible: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this.$nextTick(() => {
            this.$vuetify.goTo(this.$refs.booking_pickup_delivery);
          });
        }
      }
    }
  },
  methods: {
    swapPickupAndDelivery() {
      const pickup = this.$store.state.booking.data.pickup;
      const delivery = this.$store.state.booking.data.delivery;
      this.$store.commit("booking/updateDelivery", pickup);
      this.$store.commit("booking/updatePickup", delivery);
    },
    forceFocus() {
      this.$nextTick(() => {
        this.$vuetify.goTo(this.$refs.booking_pickup_delivery);
      });
    }
  }
};
</script>
